export const setCookie = (name, value, days) => {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  };
  
  export const getCookie = (name) => {
    const cookieName = name + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(cookieName) === 0) {
        return cookie.substring(cookieName.length, cookie.length);
      }
    }
    return null;
  };

  // --- Analytics cookie consent ---------------------------------------------
  // The visitor's analytics choice, stored as "v<version>:<true|false>:<ISO
  // timestamp>". The version prefix is the point: the stored choice is only
  // valid for the vendor list it was made against, so bumping CONSENT_VERSION
  // invalidates every older cookie - including the pre-version "true"/"false"
  // ones, which never carried a version - and the banner re-asks everyone.
  //
  // v1 (implicit, unversioned): banner text mentioned "analytics" only, and
  //                            the only tag behind it was Matomo.
  // v2 (current): Google tag (G-3W3Q167WB3) + LinkedIn Insight + Matomo.
  // Bump this whenever the tag/vendor list changes.
  export const CONSENT_COOKIE = 'cookiesAccepted';
  export const CONSENT_VERSION = 2;
  const CONSENT_DAYS = 365;

  // The timestamp is when the visitor made the choice; it lives in their
  // browser only, so it records the decision but cannot on its own prove it
  // to anyone else (see the note in CookieConsent).
  export const writeConsent = (accepted) => {
    const stamp = new Date().toISOString();
    setCookie(CONSENT_COOKIE, `v${CONSENT_VERSION}:${accepted ? 'true' : 'false'}:${stamp}`, CONSENT_DAYS);
  };

  // { accepted, decidedAt } for a choice made under the current version, or
  // null when there is no usable one (nothing stored, an older version, a
  // corrupt value). null means "ask again" and must never be read as consent.
  export const readConsent = () => {
    const raw = getCookie(CONSENT_COOKIE);
    if (!raw) return null;
    // Split on the first two colons only - the ISO timestamp contains its own.
    const firstColon = raw.indexOf(':');
    const secondColon = raw.indexOf(':', firstColon + 1);
    if (firstColon === -1 || secondColon === -1) return null;
    const version = raw.slice(0, firstColon);
    const decision = raw.slice(firstColon + 1, secondColon);
    if (version !== `v${CONSENT_VERSION}`) return null;
    if (decision !== 'true' && decision !== 'false') return null;
    return { accepted: decision === 'true', decidedAt: raw.slice(secondColon + 1) || null };
  };